import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useReducer } from 'react';
import { FormField, Input, MaskedInput, ModalWindow } from '@cian/ui-kit';
import { Form, FormActions, Success, FormError } from './internal/components';
import { reducer, initialState, setValues, setErrors, setFormStatus, resetForm } from './internal/state';
import { validateInputs, hasErrors } from './internal/utils';
import { FORM_DEFAULT_ERROR } from './constants';

/**
 * Модальное окно для отправки контактов.
 * Зачастую используется для заявок на обратный звонок/консультацию.
 *
 * Состояние и валидацию полей контроллирует самостоятельно.
 * Форма не использует сторонние библиотеки.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LeaveContactsModal = function LeaveContactsModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit,
    onInputChange = _ref.onInputChange,
    texts = _ref.texts;
  var _useReducer = useReducer(reducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    _useReducer2$ = _useReducer2[0],
    values = _useReducer2$.values,
    errors = _useReducer2$.errors,
    status = _useReducer2$.status,
    dispatch = _useReducer2[1];
  useEffect(function () {
    if (!isOpen) {
      dispatch(resetForm());
    }
  }, [isOpen]);
  var handleFormSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var validationErrors, _yield$onSubmit, _status, errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              validationErrors = validateInputs(values);
              if (!hasErrors(validationErrors)) {
                _context.next = 4;
                break;
              }
              dispatch(setErrors(validationErrors));
              return _context.abrupt("return");
            case 4:
              _context.prev = 4;
              dispatch(setFormStatus('submitting'));
              _context.next = 8;
              return onSubmit(values);
            case 8:
              _yield$onSubmit = _context.sent;
              _status = _yield$onSubmit.status;
              errorMessage = _yield$onSubmit.errorMessage;
              if (!(_status === 'success')) {
                _context.next = 14;
                break;
              }
              dispatch(setFormStatus('success'));
              return _context.abrupt("return");
            case 14:
              dispatch(setErrors({
                root: errorMessage || FORM_DEFAULT_ERROR
              }));
              _context.next = 20;
              break;
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](4);
              dispatch(setErrors({
                root: FORM_DEFAULT_ERROR
              }));
            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 17]]);
    }));
    return function handleFormSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleInputChange = function handleInputChange(name, value) {
    var _setErrors;
    dispatch(setValues(_defineProperty({}, name, value)));
    dispatch(setErrors((_setErrors = {}, _defineProperty(_setErrors, name, undefined), _defineProperty(_setErrors, "root", undefined), _setErrors)));
    onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(name);
  };
  return /*#__PURE__*/_jsx(ModalWindow, {
    open: isOpen,
    onClose: onClose,
    content: status === 'success' ? /*#__PURE__*/_jsx(Success, {
      onButtonClick: onClose,
      message: texts.success
    }) : /*#__PURE__*/_jsxs(Form, {
      title: texts.title,
      subtitle: texts.subtitle,
      onSubmit: handleFormSubmit,
      children: [/*#__PURE__*/_jsx(FormField, {
        label: "\u0418\u043C\u044F",
        errorMessage: errors.name,
        required: true,
        children: /*#__PURE__*/_jsx(Input, {
          name: "name",
          value: values.name,
          onChange: function onChange(_, value) {
            return handleInputChange('name', value);
          },
          placeholder: "\u0418\u0432\u0430\u043D\u043E\u0432 \u0418\u0432\u0430\u043D",
          "data-testid": "leave-contacts-modal-name-input"
        })
      }), /*#__PURE__*/_jsx(FormField, {
        label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        errorMessage: errors.phone,
        required: true,
        withoutMargin: true,
        children: /*#__PURE__*/_jsx(MaskedInput, {
          name: "phone",
          value: values.phone,
          onChange: function onChange(value) {
            return handleInputChange('phone', value);
          },
          mask: "{+7} (000) 000-00-00",
          placeholder: "+7",
          "data-testid": "leave-contacts-modal-phone-input"
        })
      }), !!errors.root && /*#__PURE__*/_jsx(FormError, {
        children: errors.root
      })]
    }),
    footer: status === 'success' ? null : /*#__PURE__*/_jsx(FormActions, {
      onCancel: onClose,
      onSubmit: handleFormSubmit,
      isSubmitDisabled: status === 'submitting' || status === 'error'
    })
  });
};